module.exports = "module.exports = __webpack_public_path__ + \"static/media/pageHeader.d41d8cd9.template\";"